module.exports = __webpack_public_path__ + "static/fonts/Manrope-Regular.48630a92.otf";